module.exports = "fonts/poppins-v9-latin-500.woff2";